import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import LiveMap from "@/components/LiveMap";
import { MapPin, ArrowRight } from "lucide-react";

export default function Provinces() {
  const [provinces, setProvinces] = useState([]);
  const { t } = useTranslation();
  useEffect(() => { api.get("/provinces").then((r) => setProvinces(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6">
      <div className="flex items-center gap-2 mb-1">
        <MapPin className="text-rdcblue" />
        <h1 className="font-heading font-extrabold text-2xl sm:text-3xl tracking-tight">{t("provinces.title")}</h1>
      </div>
      <p className="text-sm text-muted-foreground mb-6">{t("provinces.subtitle")}</p>

      <div className="mb-8">
        <LiveMap />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {provinces.map((p, i) => (
          <Link key={p.id} to={`/province/${p.slug}`} data-testid={`province-card-${p.slug}`}
            className="group rounded-2xl border border-border bg-card p-4 hover-lift hover:border-primary/40 hover:shadow-lg fade-up"
            style={{ animationDelay: `${Math.min(i * 25, 400)}ms` }}>
            <div className="w-10 h-10 rounded-xl bg-rdcblue/10 text-rdcblue flex items-center justify-center mb-3 group-hover:bg-rdcblue group-hover:text-white transition-colors">
              <MapPin size={18} />
            </div>
            <p className="font-heading font-bold text-sm">{p.name}</p>
            <span className="text-xs text-primary flex items-center gap-1 mt-1 opacity-0 group-hover:opacity-100 transition-opacity">{t("common.see")} <ArrowRight size={12} /></span>
          </Link>
        ))}
      </div>
    </div>
  );
}
